import { postApi } from '../api/digitalVault';
import { parseFiles, parseFolders } from '../utils';
const ENDPOINT = 'uri/repository/sysattr';
const handleFileAttr = async (props, headers, logger) => {
    const data = new URLSearchParams();
    Object.entries(props).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            value.forEach((v) => data.append(key, v.toString()));
        }
        else {
            data.append(key, value.toString());
        }
    });
    const { nodeCollection } = await postApi(data, ENDPOINT, headers, logger);
    const { file, folder } = nodeCollection;
    const parsedFolders = (folder && parseFolders(nodeCollection)) || [];
    const parsedFiles = (file && parseFiles(nodeCollection)) || [];
    return [...parsedFiles, ...parsedFolders];
};
export const addFileAttr = async (props, logger) => handleFileAttr(props, {}, logger);
export const delFileAttr = async (props, logger) => handleFileAttr(props, {
    'X-HTTP-Method-Override': 'DELETE',
}, logger);
